import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard, Coins, Crown, Download, Play, Radio, Send, Smartphone, Users } from "lucide-react";
import { InstallButton } from "@/components/layout/InstallButton";
import { EventCard } from "@/pages/LiveEvents";
import { api } from "@/lib/api";
import { useCreatorOn } from "@/lib/platform";

export const LiveRail = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/live/events", { params: { featured: true } }).then((r) => setEvents(r.data.filter((e) => e.status !== "ended"))).catch(() => {}); }, []);
  if (!events.length) return null;
  return (
    <section data-testid="home-live-rail" className="px-4 sm:px-8 lg:px-14">
      <div className="mb-4 flex items-end justify-between"><h2 className="font-display text-base md:text-lg uppercase tracking-[0.28em] gold-text">Live Events</h2><Link to="/live-events" data-testid="home-live-all" className="text-xs font-bold tracking-[0.2em] text-[#D4AF37] hover:text-[#FFD86A]">VIEW ALL</Link></div>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{events.slice(0, 3).map((e) => <EventCard key={e.slug} e={e} />)}</div>
    </section>
  );
};

const PILLARS = [
  { key: "watch", icon: Play, title: "WATCH", text: "Cinematic AETRYX Originals, series and shorts in black-and-gold glory.", to: "/browse", cta: "Browse" },
  { key: "create", icon: Clapperboard, title: "CREATE", text: "Script, cast, storyboard and poster your universe with AI.", to: "/create", cta: "Open Studio", ai: true },
  { key: "publish", icon: Send, title: "PUBLISH", text: "Distribution Ready: submit your finished work to AETRYX review and prepare packages for your own pitches.", to: "/studio/uploads", cta: "Submit work" },
  { key: "earn", icon: Coins, title: "EARN", text: "Creator revenue share and tips — coming soon.", soon: true },
];

const WATCH_PILLARS = [
  { key: "watch", icon: Play, title: "WATCH", text: "Cinematic AETRYX Originals, series and shorts in black-and-gold glory.", to: "/movies", cta: "Browse" },
  { key: "originals", icon: Crown, title: "ORIGINALS", text: "Worlds you won't find anywhere else — new AETRYX Originals every season.", to: "/originals", cta: "Explore" },
  { key: "live", icon: Radio, title: "LIVE", text: "Premieres, watch parties and live events streamed in real time.", to: "/live-events", cta: "See events" },
  { key: "profiles", icon: Users, title: "FOR EVERYONE", text: "Up to 5 profiles with kids-safe viewing and your own Continue Watching.", to: "/pricing", cta: "See plans" },
];

export const HomeFeatures = () => (
  <section data-testid="home-features" className="px-4 sm:px-8 lg:px-14">
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {(useCreatorOn() ? PILLARS : WATCH_PILLARS).map((p) => {
        const inner = (
          <>
            <p.icon className={`h-7 w-7 ${p.ai ? "text-[#00F0FF]" : "text-[#D4AF37]"}`} />
            <p className="mt-4 font-display text-xl font-bold tracking-[0.2em] gold-text">{p.title}</p>
            <p className="mt-2 text-sm text-white/65">{p.text}</p>
            <p className={`mt-4 text-xs font-bold tracking-[0.2em] ${p.soon ? "text-[#7CF7FF]/70" : "text-[#FFD86A]"}`}>{p.soon ? "COMING SOON" : `${p.cta.toUpperCase()} →`}</p>
          </>
        );
        const cls = "block rounded-2xl border border-[#D4AF37]/20 bg-[#0B0B0D] p-6 transition-[transform,border-color] duration-300";
        return p.soon ? <div key={p.key} data-testid={`pillar-${p.key}`} className={`${cls} opacity-80`}>{inner}</div>
          : <Link key={p.key} to={p.to} data-testid={`pillar-${p.key}`} className={`${cls} hover:-translate-y-1 hover:border-[#D4AF37]/60`}>{inner}</Link>;
      })}
    </div>
    <div data-testid="pwa-card" className="mt-6 flex flex-col items-start gap-5 overflow-hidden rounded-2xl border border-[#D4AF37]/30 bg-gradient-to-r from-[#16130A] to-[#0B0B0D] p-6 sm:flex-row sm:items-center sm:p-8">
      <img src="/assets/art/app_icon_crown.jpg" alt="AETRYX app icon" className="h-20 w-20 rounded-2xl border border-[#D4AF37]/40" />
      <div className="flex-1"><p className="eyebrow flex items-center gap-2"><Smartphone className="h-4 w-4" /> AETRYX Movie App</p><p className="mt-1 font-display text-2xl font-bold text-white">Take the universe with you</p><p className="mt-1 text-sm text-white/60">Install AETRYX on your phone or desktop — full-screen, fast, one tap away.</p></div>
      <InstallButton testId="pwa-card-install" className="btn-gold px-6 py-3 text-sm" />
      <Download className="hidden" />
    </div>
  </section>
);
